import styles from '../../../../scss/newsletter/newsletter.styles.scss.js'

const HtmlHead = ({title, stylesFontFaces}) => (
    <head>
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{title}</title>
        <style type="text/css">{stylesFontFaces}</style>
        <style type="text/css">{styles}</style>
    </head>
)

export default HtmlHead